import { render, staticRenderFns } from "./buildingManage.vue?vue&type=template&id=7ae4cbce&scoped=true"
import script from "./buildingManage.vue?vue&type=script&lang=js"
export * from "./buildingManage.vue?vue&type=script&lang=js"
import style0 from "./buildingManage.vue?vue&type=style&index=0&id=7ae4cbce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae4cbce",
  null
  
)

export default component.exports